module.exports = __webpack_public_path__ + "static/media/bg-hills-tablet.39b7d292.jpg";